import { useEffect } from 'react';

export default function useAsyncEffect(effect: () => Promise<unknown>, deps: any[]) {
	useEffect(() => {
		effect();
	}, deps);
}
